import React from "react";

import post_banner from "../../../assets/images/post_banner.png"
import { formatDate } from "../../../helpers/formatDate"

import {
  Card,
  Content,
  Created,
  Image,
  Tag,
  Tags,
  Title
} from "./styles";

type TagType = {
  id: number;
  name: string;
};

type Props = {
  postImg: string;
  postCreatedAt: string;
  postTitle: string;
  postTags: TagType[];
  postId: number;
  onClick: (id: number) => void;
};

export const Post: React.FC<Props> = ({
  postImg,
  postCreatedAt,
  postTitle,
  postTags,
  postId,
  onClick,
}) => {
  return (
    <Card data-id={postId} onClick={() => onClick(postId)}>
      <Image src={postImg || post_banner} alt={postTitle} />
      <Content>
        <Created>{formatDate(postCreatedAt)}</Created>
        <Title>{postTitle}</Title>
        <Tags>
          {postTags.map((tag) => (
            <Tag key={tag.id}>{tag.name}</Tag>
          ))}
        </Tags>
      </Content>
    </Card>
  );
};
